import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/HeroSection';
import VisionMission from '../components/VisionMission';
import ValueCircle from '../components/ValueCircle';
import ResiliencePopup from '../components/ResiliencePopup';

const Home = () => {
  return (
    <div data-testid="home-page">
      <Helmet>
        <title>Rachelle Cooper Kulkarni | Sustainify® | Sustainability Consultant Sunshine Coast Australia</title>
        <meta name="description" content="Rachelle Cooper Kulkarni is the Founder & Principal Consultant of Sustainify®, a Sunshine Coast sustainability consulting social enterprise. Rachelle Cooper Kulkarni leads strategy, governance, climate and just transition advisory for organisations across Australia." />
        <meta name="keywords" content="Rachelle Cooper Kulkarni, Rachelle Kulkarni, Rachelle Cooper, Sustainify, Sustainify consultant, Rachelle Cooper Kulkarni Sunshine Coast, Rachelle Cooper Kulkarni Sustainify, sustainability consultant Australia, just transition consultant, climate consultant Queensland, Sustainify founder" />
        <link rel="canonical" href="https://www.sustainify.com.au/" />
      </Helmet>
      <ResiliencePopup />
      <HeroSection />
      <VisionMission />
      <ValueCircle />
      
      {/* Transformation Section */}
      <section className="py-20 bg-ozone-white" data-testid="transformation-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09"
                alt="Sustainable transformation"
                className="rounded-2xl shadow-2xl"
              />
            </div>
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-basalt-carbon mb-6">
                The Transformation
              </h2>
              <p className="text-xl text-basalt-carbon/80 mb-6 leading-relaxed">
                <strong className="text-kabi-teal">People and planet at the heart.</strong>
              </p>
              <p className="text-lg text-basalt-carbon/70 leading-relaxed">
                We don't hand you a report and leave. We deliver strategic, systems change. 
                Real work. Real clients. Real outcomes.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;